import { HISTORIQUE_POINTS_ROUTES as ptsRoutes } from "~/api/routes";
import axios from 'axios'

export const state = () => ({
    historiques: [],
    pagination: {},
    currentpoints: 0,
    compte_id: null,
    compte: null,
    isRequesting: false
});

export const getters = {};

export const mutations = {
    HISTORIQUE_POINTS_LOAD(state) {
        //state.isRequesting = true;
        state.hasError = false;
        state.historiques = [];
        //state.page = page;
    },
    HISTORIQUE_POINTS_SUCCESS(state, response) {
        state.historiques = response.data;
        //state.pagination = params.payload.pagination;
        //state.filters = params.filters || state.filters;
    },
    HISTORIQUE_POINTS_PAGINATION(state, pagination) {
        delete pagination.data;
        state.pagination = pagination
    },
    HISTORIQUE_POINTS_ERROR(state, error) {
        state.historiques = [];
        state.hasError = true;
        state.isRequesting = false;
    },
    IS_REQUESTING(state, isRequesting) {
        state.isRequesting = isRequesting;
    },
    SET_CURRENT_COMPTE_ID(state, params) {
        try {
            state.compte_id = params.compte_id;
            state.compte = params;
        } catch (e) {
            state.compte_id = null;
        }
    },
    SET_CURRENT_POINTS(state, params) {
        try {
            state.currentpoints = params.points;
        } catch (e) {
            state.currentpoints = 0;
        }
    },
    SET_CURRENT_HISTORIQUE_POINTS(state, params) {
        try {
            state.historiques = params.historique;
        } catch (e) {
            state.historiques = [];
        }
    },
  CLEAR_STATE(state, ) {

            state.historiques =[];

    }
};

export const actions = {
    async getHistoriquepoints({ commit }, params) {
        commit('CLEAR_STATE');
        commit('IS_REQUESTING', true);
        const queryUrl = { ...ptsRoutes.get };
        queryUrl.endPoint += '?page=' + (params.page ? params.page : 1);
        await this.$api.request(queryUrl, { id: params.compte_id }, params.formData)
            .then(response => {
                commit('HISTORIQUE_POINTS_SUCCESS', response.payload);
                commit('HISTORIQUE_POINTS_PAGINATION', response.payload);
            })
            .catch(error => {
                commit('HISTORIQUE_POINTS_ERROR', error);
            })
            .finally(() => commit('IS_REQUESTING', false));
    },
    async setCompteId({ commit }, params) {
        commit('SET_CURRENT_COMPTE_ID', params);
    },
    async setPoints({ commit }, params) {
        commit('SET_CURRENT_POINTS', params);
    },
    async setHistoriquePoints({ commit }, params) {
        commit('SET_CURRENT_HISTORIQUE_POINTS', params);
    }
};
